//import views
import permission from "@/middlewares/permission";


function loadView(view) {
    return () => import(`@/views/admin/reports/${ view }.vue`);
}


const Index = loadView('Index');

const reportRoutes = [
    {
        path: 'reports',
        name: 'api.report',
        component: Index,
        meta: {
            middleware: permission
        }
    }
];

export default reportRoutes;